import DarkImages from '../Dark/Images';
import LightImages from '../Light/Images';

const getThemeImages = themeName => {
  switch (themeName) {
    case 'light':
      return LightImages;
    case 'dark':
      return DarkImages;
    default:
      return LightImages;
  }
};

export { getThemeImages }; // eslint-disable-line import/prefer-default-export
